var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublishIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59556 2.31145C3.08224 0.966403 4.42201 0 5.99995 0C7.57789 0 8.91782 0.966403 9.40434 2.31145C10.87 2.49952 12 3.69553 12 5.14299C12 6.72088 10.6568 8 9.0001 8H6.59998V5.37956L7.37575 6.11838C7.61009 6.34147 7.99 6.34147 8.22434 6.11838C8.45858 5.89519 8.45858 5.53338 8.22434 5.31021L6.4243 3.5959C6.18995 3.37281 5.81004 3.37281 5.5757 3.5959L3.77566 5.31021C3.54132 5.53339 3.54132 5.8952 3.77566 6.11838C4.01001 6.34147 4.38991 6.34147 4.62425 6.11838L5.40002 5.37956V8H2.9999C1.34298 8 0 6.72079 0 5.14299C0 3.69558 1.12983 2.49953 2.59556 2.31145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publish-icon.b49a9b6a3bcec4ef31df8996929aaffd.svg";
export { ForwardRef as ReactComponent };